// extracted by mini-css-extract-plugin
export default {"container":"StudentPersonalDetailsLayout__container___LIYWS","content":"StudentPersonalDetailsLayout__content___fbNpY"};